import { Pipe, PipeTransform } from '@angular/core';
import { UrlSasDTO } from '../models/AzureStorage/UrlSasDTO';
import { ImageCacheService } from '../services/ImageCache.service';

@Pipe({
  name: 'nameToSingular'
})
export class NameToSingularPipe implements PipeTransform {
  constructor() {}

  transform(word: string): string {
    if (!word) return word;
    if (word.endsWith("iones")) {
      return word.slice(0, -5) + "ión"; // ubicac iones 
    }
    if (word.endsWith("enes")) {
      return word.slice(0, -4) + "én"; //almac enes
    }
    if (word.endsWith("es")) {
      return word.slice(0, -2);
    }
    if (word.endsWith("s")) {
      return word.slice(0, -1);
    }
    return word;
  }
}